import { ApiRequest, ApiRequestNoLoder } from "../../services/api"

export const HardDeleteUser = async (userId) => {
    return await ApiRequest("DELETE", "users/delete-user?user_id=" + userId)
}

export const DeleteCleanupLogs = async (days = 30) => {
    return await ApiRequest("DELETE", `admin/error-logs/cleanup?days=${days}`);
}

export const DeleteErrorLog = async (errorId) => {
    return await ApiRequest("DELETE", `admin/error-logs/${errorId}`);
}

export const DeleteUserPhotos = async (userId, photoUrls) => {
    return await ApiRequest("DELETE", "admin/v2/delete-user-photos", {
        userId,
        photoUrls,
    });
}

export const DeleteUserCache = async (userId) => {
    return await ApiRequest("DELETE", `admin/cache/clear-user?userId=${encodeURIComponent(userId)}`);
}

export const DeleteCreditPackage = async (packageId) => {
    return await ApiRequest("PATCH", `admin/credit-packages/${packageId}/deactivate`);
}

export const DeleteWhatsappMetaTemplate = async (name) => {
    return await ApiRequest("DELETE", `admin/whatsapp/meta-templates?name=${encodeURIComponent(name)}`);
}

export const DeleteWhatsappDbTemplate = async (templateIdOrKey) => {
    return await ApiRequest("DELETE", `admin/whatsapp/db-templates/${encodeURIComponent(templateIdOrKey)}`);
}
